class SingleCourseCtrl {
  constructor($scope, course) {
    $scope.course = course?.data;
  }
}

SingleCourseCtrl.$inject = ['$scope', 'course'];

export default SingleCourseCtrl;
